import React, { useEffect, useState } from "react";

import "./styles/index.scss";
import { connect } from "react-redux";
import Actions from "../../../actions";
import { clickToLinkHandler } from "../../../helpers/utils";

import {
  getDocumentsFilters,
  getDocumentsList,
  getDocumentUpdatedStatus,
} from "../../../reducers/selectors";
import ViewInvestor from "./DealInvestors";
import Button from "../../common/forms/button";
import { configureAuthHeader } from "../../../api/axiosConfig";
import * as api from "../../../api/generated-api";
import { processUnexpectedError } from "../../../api/errors";
import { isCompanyMemberOrCounselForDeal } from "../../../helpers/utilsTS";
import history from "../../../middlewares/history";
import Delimiter from "../../common/forms/delimiter/Delimiter";
import { getDealLegalEntitiesForUser } from "../../../api/deals/deallegalentities";
import { UserWithPersonWithOrganizationPersons } from "../../../api/types";
import { DealsPageEmptyState } from "../dealsPageLayout/DealsPageEmptyState/DealsPageEmptyState";

type InvestorsDealsProps = {
  user: UserWithPersonWithOrganizationPersons;
  token: string;
  dealId: number;
  orgId: number;
};
const DealInvestorsPage = (props: InvestorsDealsProps) => {
  const { dealId, orgId, token, user } = props;

  configureAuthHeader(token);

  const [deal, setDeal] = useState<api.Deal>(null);
  const [investors, setInvestors] = useState<api.DealInvestor[]>([]);
  const [dealLegalEntitiesForUser, setDealLegalEntitiesForUser] = useState<
    api.DealLegalEntity[]
  >([]);

  useEffect(() => {
    getDealLegalEntitiesForUser(orgId, dealId, (fetchedDealLegalEntities) => {
      setDealLegalEntitiesForUser(fetchedDealLegalEntities);
    });
  }, [orgId, dealId]);

  useEffect(() => {
    const fetchDeal = async (dealId) => {
      const result = await api.getDealById(orgId, dealId);
      setDeal(result.data);
    };

    const fetchInvestors = async (dealId) => {
      const result = await api.getDealInvestors(orgId, dealId);
      setInvestors(result.data);
    };

    if (dealId && !deal) {
      fetchDeal(dealId).catch((error) => {
        processUnexpectedError(error);
      });
      fetchInvestors(dealId).catch((error) => {
        processUnexpectedError(error);
      });
    }
  }, [dealId, deal]);

  if (!deal || !dealLegalEntitiesForUser) {
    return null;
  }

  const isCompanyMember = isCompanyMemberOrCounselForDeal(
    user.person.organizations_persons,
    orgId,
    dealId,
    dealLegalEntitiesForUser
  );

  return (
    <div className="create-deals-form-container">
      <div className="deals-title-container">
        <div className="title-form">
          Investors <span>{investors?.length || ""}</span>
        </div>
        {isCompanyMember && (
          <Button
            type="secondary"
            size="medium"
            children={"add investor"}
            onClick={clickToLinkHandler.bind(
              this,
              "/" + orgId + "/deals/" + deal.id + "/edit/investors/create"
            )}
          />
        )}
      </div>
      <Delimiter type="headline" shift={18} />
      {!investors.length && (
        <DealsPageEmptyState
          title={"Add your first investor"}
          content={"Build the roster of everyone investing in your round"}
        />
      )}
      <div className="view-deals-investors">
        {!!investors.length &&
          investors.map((investor, key) => {
            return (
              <ViewInvestor
                key={"investor_" + key}
                investor={investor}
                onInvestorOpen={(legalEntitiesFormFocus) => {
                  history.push({
                    pathname:
                      "/" +
                      orgId +
                      "/deals/" +
                      deal.id +
                      "/edit/investors/edit/" +
                      investor.id,
                    state: {
                      legalEntitiesFormFocus: legalEntitiesFormFocus || false,
                    },
                  });
                }}
                dealId={dealId}
                organizationId={orgId}
              />
            );
          })}
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const {
    match: {
      params: { dealId, orgId },
    },
  } = props;
  const { token, user } = state.auth;
  const templatesActionStatus = state.actionStatus.GET_TEMPLATES_LIST;
  const documentsListActionStatus = state.actionStatus.GET_DOCUMENTS_LIST;
  return {
    token,
    user,
    orgId,
    dealId,
    templatesActionStatus,
    documentsListActionStatus,
    location: props.location,
    documents: getDocumentsList(state),
    documentFilters: getDocumentsFilters(state),
    updatedStatus: getDocumentUpdatedStatus(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getDeal: function (dealId) {
    dispatch(Actions.getDeal(dealId));
  },
  getCategories: function () {
    dispatch(Actions.getCategories());
  },
  getTemplates: function () {
    dispatch(Actions.getTemplates());
  },
  getDocuments: function (offset, limit, order, direction, filters) {
    dispatch(Actions.getDocuments(offset, limit, order, direction, filters));
  },
  updateDocument: function (documentId, data) {
    dispatch(Actions.updateDocument(documentId, data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DealInvestorsPage);
